import createReducer from '../utils/createReducer';
import actions from '../actions/basicInformation';
import {validateEmail, checkBasicInfoBtnStatus} from '../utils/validate';

const initialState = {};

const actionHandlers = {

    [actions.SET_FIRST_NAME](state, {payload}) {
        return {
            ...state,
            firstName: payload.fieldVal
        };
    },

    [actions.SET_LAST_NAME](state, {payload}) {
        return {
            ...state,
            lastName: payload.fieldVal
        };
    },

    [actions.SET_EMAIL](state, {payload}) {
        return {
            ...state,
            email: payload.fieldVal
        };
    },

    [actions.SET_FIELD_ERROR](state, {payload}) {
        if (payload.field === 'firstName') {
            return {
                ...state,
                firstNameError: payload.msg
            };
        } else if (payload.field === 'lastName') {
            return {
                ...state,
                lastNameError: payload.msg
            };
        } else if (payload.field === 'email') {
            return {
                ...state,
                emailError: payload.msg
            };
        }

        return {
            ...state
        };
    },

    [actions.VALIDATE_EMAIL](state, {payload}) {
        const isValidEmailAddress = validateEmail(payload.fieldVal);
        if (!isValidEmailAddress) {
            return {
                ...state,
                emailError: 'ipmob.create_account.button.text_5',
                enableContinueButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.TOGGLE_BASIC_INFO_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkBasicInfoBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.PRE_POPULATE_BASIC_DETAILS](state, {payload}) {
        const {firstName, lastName} = payload.brandSwitchParams;

        return {
            ...state,
            firstName,
            lastName
        };
    }
};

export default createReducer(actionHandlers, initialState);
